import { z } from 'zod';

export const notificationKindSchema = z.enum([
  'account_verification',
  'document_refused',
  'document_a_completer',
  'payment_validated',
  'appointment_scheduled',
  'project_status_updated',
  'report_available',
  'partner_compliance_reminder',
  'partner_compliance_refused',
  'partner_intervention_assigned',
  'partner_intervention_reviewed',
  'partner_invoice_paid',
  'appointment_slots_proposed',
  'appointment_assigned',
  'appointment_confirmed',
]);
export type NotificationKind = z.infer<typeof notificationKindSchema>;

export const notificationChannelSchema = z.enum(['email', 'sms']);
export type NotificationChannel = z.infer<typeof notificationChannelSchema>;
